import File from '../file'

export default class RouteFile extends File {
  isChild () {
    return /.child.js$/i.test(this.getFullPath()) === true
  }
}
